import React from "react";
import BannerHero from "@/components/bannerHero";
import UnderConstruction from "@/components/UnderConstruction";

const UnderConstructionPage: React.FC = () => {
    return (
        <>
            <BannerHero
                title="Under Construction"
                bgImage="/images/about-bg.png"
                className="about"
            />
            <UnderConstruction />
        </>
    );
};

export default UnderConstructionPage;
